import { client } from "../../../api/client";
import {CommandDispatcher, dispatch_and_wait_job} from "../domain/CommandDispatcher"
import { jobs } from "@/api/jobs.js"

export class AsyncAPICommandDispatcher implements CommandDispatcher{
  dispatch(cmd_name,args): Promise<{[key: string]: any} > {
    let command_args = args
    command_args['cmd_name'] = cmd_name
    let p = new Promise<{[key: string]: any}>(function(resolve, reject){
      client
      .post(`async_command_bus/`,{command:command_args}).
      then(response => resolve(response.data)).
      catch(e => reject(e))
    })
    return p
  }

  async dispatch_with_result(cmd_name,args,sleep_time_ms): Promise<{[key: string]: any}> {
    return await dispatch_and_wait_job(cmd_name, args, this, jobs, sleep_time_ms)
  }
}